import { containerColumns } from '@Constants/TableColumns';
import { EnumFrontendLayoutSetting, type ApiImportableContainer, ApiImportExternalErpItemsRequest } from '@Model';
import { useStammdatenRepository } from '@Hooks/useRepository';
import { ExternalErpContainersRepository } from '@Repositories/Stammdaten';
import { useCallback } from 'react';
import type { ListRequest } from '@synqo/frontend-component-library';
import { type ImportFlowControlProps, ImportExternalErpItemsFlow } from './ImportExternalErpItemsFlow';

// @ai-generated 2026-10-22T13:20:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function ImportExternalErpContainersFlow({ isOpen, onClose, onImported }: ImportFlowControlProps) {
    const repository = useStammdatenRepository(ExternalErpContainersRepository);

    const loadImportable = useCallback(
        (listRequest: ListRequest) => repository.getImportableContainers(listRequest),
        [repository],
    );
    const importSelected = useCallback(
        (request: ApiImportExternalErpItemsRequest) => repository.importContainers(request),
        [repository],
    );

    return (
        <ImportExternalErpItemsFlow<ApiImportableContainer>
            isOpen={isOpen}
            onClose={onClose}
            onImported={onImported}
            title="Container aus ERP importieren"
            name="ErpContainerList"
            itemsLabel="Container"
            columns={containerColumns}
            layoutSettingsContext={EnumFrontendLayoutSetting.ContainersTableLayout}
            loadImportable={loadImportable}
            importSelected={importSelected}
        />
    );
}
